module.exports = __webpack_public_path__ + "static/media/ic_update_dealer_code.638771ca.svg";